/**
 * Recovery Redirect Component
 * Detects password recovery tokens in the URL and redirects to auth callback
 * This fixes the issue where Supabase redirects to / instead of /auth/callback
 */

import { useEffect } from 'react';
import { useLocation } from 'wouter';

interface RecoveryRedirectProps {
  children: React.ReactNode;
}

export const RecoveryRedirect: React.FC<RecoveryRedirectProps> = ({ children }) => {
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Check if URL contains recovery token
    const hash = window.location.hash;
    const search = window.location.search;

    // Check both hash and search params for recovery indicators
    const hasRecoveryToken =
      hash.includes('type=recovery') ||
      hash.includes('access_token') ||
      search.includes('type=recovery') ||
      search.includes('code='); // PKCE code for token exchange

    if (hasRecoveryToken) {
      console.log('[RecoveryRedirect] Recovery token detected in URL, redirecting to auth callback...');
      console.log('[RecoveryRedirect] Hash:', hash);
      console.log('[RecoveryRedirect] Search:', search);

      // Clear any cached auth state that might interfere
      localStorage.removeItem('auth_mode');
      localStorage.removeItem('auth_step');

      // Find and remove any cached email
      const emailKey = Object.keys(localStorage).find(key => key.includes('user_email'));
      if (emailKey) {
        console.log('[RecoveryRedirect] Removing cached email to prevent "Welcome back" page');
        localStorage.removeItem(emailKey);
      }

      // Redirect to auth callback with the same hash and search params
      const fullParams = `${search}${hash}`;
      console.log('[RecoveryRedirect] Redirecting to: /auth/callback' + fullParams);
      window.location.href = `/auth/callback${fullParams}`;
    }
  }, [setLocation]);

  return <>{children}</>;
};
